import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Imoveis from "./Imoveis";
import Imovel from "./Imovel";
import NotFound from "./NotFound";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/imoveis/:tipo" element={<Imoveis />} />
        <Route path="/imovel/:id" element={<Imovel />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
